export const getOptions = (params: any, suffix?: string) => {
  return   params?.length >= 1 ? params.map(({ value, name }) => ({ value, name: suffix ? `${name}${suffix}` : name })) : [];
}

